export default {
  nextButtonLabel: 'Enregistrer les modifications',
  sidebar: {
    title: 'Fiabiliser mes indicateurs',
    subtitle: 'Veuillez mettre à jour vos données :',
  },
  table: {
    house: 'Foyer',
  },
  liability: {
    title: 'Vos charges',
    hint: 'La modification de ces données entrainera une mise à jour de vos informations budgétaires.',
    tableTitle: 'Charges déductibles annuelles',
    alimonies: 'Pensions alimentaires',
    other_liabilities: 'Autres charges',
    extraordinary_liability: 'Charges exceptionnelles',
  },
  extraordinaryLiability: {
    tableTitle: 'Autres charges déductibles annuelles',
  },
  deficit: {
    title: 'Déficits antérieurs',
    home: 'Foyer',
    rentalIncome: 'Déficits fonciers',
    lmnp: 'Déficits issus de la location meublée non professionnelle',
    globalIncome: 'Déficits globaux antérieurs non encores déduits',
    hint: 'Scénarios fiscaux calculés à partir de l\'année N = {year}',
    yearlyDeficit: 'Déficit pour l\'année {index}',
  },
  income: {
    title: 'Vos revenus',
    hint: 'La modification de ces données entrainera une mise à jour de vos informations budgétaires.',
    cardTitle: 'Option pour l\'imposition au barème progressif',
    cardSubtitle:
      'Pour vos revenus de capitaux mobiliers et  vos plus-values de cession de valeurs mobilières :',
    tableTitle: 'Revenus imposables annuels',
    revenu_activite: 'Revenus d\'activité',
    pension: 'Pensions, retraites et rentes',
    revenu_patrimoine: 'Revenus du patrimoine',
    revenu_sociaux: 'Revenus sociaux',
    extraordinary_income: 'Revenus exceptionnels',
  },
  extraordinaryIncome: {
    tableTitle: 'Revenus imposables annuels - exceptionnels',
  },
  patrimony: {
    advantages: {
      SOFICA: {
        type: 'Sofica',
        title: 'Versement éligible à une réduction d\'impôt sur le revenu',
        subtitle:
          'Renseigner la somme des versements réalisés cette année sur cette categorie d\'investissement',
        fields: {
          amountStandard: 'Montant - taux standard',
          amountIncreased: 'Montant - taux majoré',
          amountIncreasedSupp: 'Montant - taux majoré supplémentaire',
        },
      },
      FCPI: {
        type: 'FCPI',
        title: 'Versement éligible à une réduction d\'impôt sur le revenu',
        subtitle:
          'Renseigner la somme des versements réalisés cette année sur cette categorie d\'investissement',
        fields: {
          amount: 'Montant',
        },
      },
      FIP: {
        type: 'FIP',
        title: 'Versement éligible à une réduction d\'impôt sur le revenu',
        subtitle:
          'Renseigner la somme des versements réalisés cette année sur cette categorie d\'investissement',
        fields: {
          amount: 'Montant',
        },
      },
      FIP_CORSE: {
        type: 'FIP CORSE',
        title: 'Versement éligible à une réduction d\'impôt sur le revenu',
        subtitle:
          'Renseigner la somme des versements réalisés cette année sur cette categorie d\'investissement',
        fields: {
          amount: 'Montant',
        },
      },
      GIRARDIN_LOGEMENT: {
        type: 'Girardin Logement',
        title: 'Montant de la réduction d\'impôt',
        subtitle:
          'Renseigner le montant total de réduction dont vous bénéficiez au titre de ces investissements',
        fields: {
          amount: 'Montant',
        },
      },
      GIRARDIN_INDUSTRIEL: {
        type: 'Girardin Industriel',
        title: 'Montant de la réduction d\'impôt',
        subtitle:
          'Renseigner le montant total de réduction dont vous bénéficiez au titre de ces investissements',
        fields: {
          amountPleinDroit: 'Montant - Régime de plein droit',
          amountFiscal: 'Montant - Régime avec agrément fiscal',
        },
      },
      GFI: {
        type: 'GFI',
        title: 'Versement éligible à une réduction d\'impôt sur le revenu',
        subtitle:
          'Renseigner la somme des versements réalisés cette année sur cette categorie d\'investissement',
        fields: {
          amount: 'Montant',
        },
      },
    },
  },
  retirement: {
    tabsAll: 'Voir tous ({count})',
    sortOptions: {
      desc: 'Trier: Montant décroissant',
      asc: 'Trier: Montant croissant',
    },
    contract: {
      title: 'Versements effectués',
      subtitle: 'Renseigner les versements effectués sur ce contrat',
      inputLabel: 'Versements (année en cours)',
    },
    ceiling: {
      sectionTitle: 'Veuillez indiquer les plafonds non utilisés pour les revenus des années précédentes',
      cardTitle: 'Plafonds déductibles de l\'impôt sur le revenu',
      ceilingPerYear: 'Plafond non utilisé pour les revenus N-{count}',
      ceilingCurrentYear: 'Plafond calculé sur les revenus de l\'année N-1'
    }
  },
  yourSituation: {
    currentUser: {
      title: 'État civil',
      hint: 'Vous pouvez modifier et compléter les données de votre foyer fiscal dans la section "Votre situation" de l\'application',
      taxableHousehold: {
        title: 'Votre foyer fiscal',
        description: 'Ces informations ont un impact sur votre imposition :',
        maritalStatusSelectInputLabel: 'Statut marital',
        maritalStatusSelectInputPlaceholder:
          'Sélectionner votre statut marital',
        singleParentLabel: 'Demi-part pour parent isolé :',
        livingAlonePersonLabel: 'Demi-part pour personne vivant seule :',
        livingAlonePersonHintLabel:
          'Ayant eu au moins une personne à charge pendant 5 ans ou plus.',
      },
      taxableHouseholdOfChild: {
        title: 'Prise en compte dans votre foyer fiscal',
        dependentLabel: 'Rattaché fiscalement',
        alternateResidenceLabel: 'Résidence alternée',
        handicapLabel: 'Situation de handicap',
      },
    },
  },
  budget: {
    drawer: {
      amount: 'Montant',
      amountReduction: "Montant de l'abattement renforcé",
      infoMessage: 'Veuillez renseignez ci-dessous les montants des revenus d’activité mensuels avant impôt sur le revenu :',
    },
  },
}

export const kycI18nRoot = 'taxationCircuit.steps.kyc'
